<script lang="ts">
import { h, defineComponent, resolveComponent } from 'vue';
import { linebreakKeyMap } from '@prosemirror/schema/plainAndLinebreakUtil';
import lineBreakSchema from '@prosemirror/schema/lineBreakSchema';

export default defineComponent({
  name: 'ProsemirrorInputBox',
  functional: true,

  render() {
    const children = [];

    const { label, blurOnEnter, focusOnMount, modelValue, placeholder, editable, maxLength, doubleHeight } = this;

    const input = h(resolveComponent('ProsemirrorInput'), {
      label,
      blurOnEnter,
      focusOnMount,
      modelValue,
      placeholder,
      editable,
      maxLength,
      doubleHeight,
      keymap: linebreakKeyMap,
      schema: lineBreakSchema,
      ...this.$attrs,
      class: ['prosemirror-input--boxed', this.doubleHeight ? 'prosemirror-input--boxed__double-height' : ''],
    });

    if (this.label) {
      children.push(
        h(
          'div',
          {
            class: 'prosemirror-input__label input-box__label',
            onClick: () => {
              input.component.proxy.focus();
            },
          },
          [this.label]
        )
      );
    }

    children.push(input);

    return h(
      'div',
      {
        class: 'prosemirror-input__wrapper',
      },
      children
    );
  },

  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },

    blurOnEnter: {
      type: Boolean,
      required: false,
      default: false,
    },

    focusOnMount: {
      type: Boolean,
      required: false,
      default: false,
    },

    modelValue: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      required: false,
      default: '',
    },

    editable: {
      type: Boolean,
      required: false,
      default: true,
    },

    maxLength: {
      type: Number,
      required: false,
      default: Infinity,
    },

    doubleHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});
</script>

<style lang="scss">
.prosemirror-input__wrapper {
  --input-min-height: 80px;

  min-width: 0;

  .prosemirror-input--boxed__double-height {
    min-height: var(--input-min-height);
    max-height: calc(var(--input-min-height) * 3);
    overflow: auto;
  }
}
</style>
